import type {BlobPayload} from '@github-ui/code-view-types'
import React from 'react'

export type CurrentBlob = Omit<BlobPayload, 'colorizedLines' | 'rawLines' | 'stylingDirectives'>

const CurrentBlobContext = React.createContext({} as CurrentBlob)

export function CurrentBlobProvider({blob, children}: React.PropsWithChildren<{blob: CurrentBlob}>) {
  return <CurrentBlobContext value={blob}> {children} </CurrentBlobContext>
}

export function useCurrentBlob() {
  return React.use(CurrentBlobContext)
}
